import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "plan.newHomework",
    },
    homeworkTitle: {
        id: "homework.title",
    },
    homeworkDate: {
        id: "homework.date",
    },
    homeworkStartDate: {
        id: "homework.startDate",
    },
    hour: {
        id: "hour",
    },
    minute: {
        id: "minute",
    },
    newClass: {
        id: "homework.newClass",
    },
    newClassName: {
        id: "homework.newClassName",
    },
    create: {
        id: "general.create",
    },
    classLabel: {
        id: "homework.class",
    },
    deadlineAlert: {
        id: "homework.deadlineAlert",
    },
    homeworkDescription: {
        id: "homework.description.teacherSide",
    },
    tasks: {
        id: "test.tasks",
    },
    addedClass: {
        id: "homework.new.addedClass",
    },
    addedClasses: {
        id: "homework.new.addedClasses",
    },
    repeatCreating: {
        id: "homework.new.repeatCreating",
    },
    experience: {
        id: "exercise.solve.solveAsExperience"
    },
    privacy: {
        id: "homework.new.privacy"
    },
    easter: {
        id: "easter.eggPainting",
    },
    theme: {
        id: "experienceEditor.theme",
    },
    basic: {
        id: "experienceEditor.theme.basic",
    },
    order: {
        id: "experienceEditor.order.label"
    },
    fix: {
        id: "experienceEditor.order.fix",
    },
    free: {
        id: "experienceEditor.order.free"
    },
    scoreOptionScore: {
        id: "experienceEditor.score.options.score",
    },
    scoreOptionTaskScore: {
        id: "experienceEditor.score.options.taskScore",
    },
    scoreLabel: {
        id: "experienceEditor.score.label",
    },
    coverImage: {
        id: "testModeration.categories.cover",
    },
    customizeExperience: {
        id: "homework.customizeExperience"
    },
    christmasTuning: {
        id: "christmas.title",
    },
});

export default messages;
